import React from 'react';
import { useTranslation } from 'react-i18next';
import Seo from '../components/Seo';

const Offline = () => {
  const { t } = useTranslation();

  return (
    <main
      style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '24px',
        textAlign: 'center',
      }}
    >
      <Seo title={t('offline.title')} description={t('offline.description')} />
      <div
        style={{
          width: '100%',
          maxWidth: 360,
          height: 200,
          marginBottom: 24,
          backgroundImage: 'url(/images/offline.jpg)',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'contain',
          backgroundPosition: 'center',
        }}
        role="img"
        aria-label={t('offline.title')}
      />

      <h1 style={{ marginBottom: '16px' }}>{t('offline.title')}</h1>
      <p style={{ marginBottom: '24px', color: '#666' }}>
        {t('offline.description')}<br />
        {t('offline.hint')}
      </p>
    </main>
  );
};

export default Offline;
